<script setup lang="ts">
import type { NovaBoxBoardDetailLinkProps } from './NovaBoxBoardDetailLink.types'

const props = defineProps<NovaBoxBoardDetailLinkProps>()
const { gtEvent } = useGoogleTag()
const { t } = useI18n()

const route = useRoute()
const { date: dateFormat } = useDateFormat()
const date = computed(() =>
  dateFormat({ date: props.boardItem.sysRegistDt, format: 'YYYY-MM-DD' })
)

const handleOnGoPrevNext = () => {
  if (props.direction === 'prev') {
    gtEvent('clickEvent', {
      eventCategory: '클릭',
      eventAction: `${props.gaSlot} 상세 > 이전글 이동`,
      eventLabel: t(`board.label.${props.direction}`),
      eventSlot: '',
      eventI18nAddr: useKoreanTranslation(`board.label.${props.direction}`),
      eventComponent: 'Button',
      nttSj: props.boardItem.nttSj,
      nttSn: props.boardItem.nttSn,
    })
  } else {
    gtEvent('clickEvent', {
      eventCategory: '클릭',
      eventAction: `${props.gaSlot} 상세 > 다음글 이동`,
      eventLabel: t(`board.label.${props.direction}`),
      eventSlot: '',
      eventI18nAddr: useKoreanTranslation(`board.label.${props.direction}`),
      eventComponent: 'Button',
      nttSj: props.boardItem.nttSj,
      nttSn: props.boardItem.nttSn,
    })
  }
  useNavigations({
    url: props.linkPath,
    query: route.query,
  })
}
</script>

<template>
  <button type="button" class="link" @click="handleOnGoPrevNext">
    <span class="label">{{ $t(`board.label.${direction}`) }}</span>
    <span class="title">{{ boardItem.nttSj }}</span>
    <span class="date">{{ date }}</span>
  </button>
</template>

<style lang="scss" scoped>
.link {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  width: 100%;
  padding: 30px 20px;
  background-color: $color-white;
  border-radius: $radius-10;
  cursor: pointer;

  &:first-child {
    margin-top: 0;
  }

  span {
    @include text-style($text-heading3-medium);
  }

  .title {
    flex-grow: 1;
    text-align: left;
    @include ellipsis(1);
  }
  .label {
    color: $color-text-3;
    flex-shrink: 0;
  }

  .date {
    flex-shrink: 0;
    @include text-style($text-body-12-regular);
    color: $color-text-3;
  }
}
</style>
